module.exports = __webpack_public_path__ + "static/media/bg-card_sales-guidance.549e5796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg/bg-card_sales-guidance.jpg
// module id = 1498
// module chunks = 0